import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  Paper,
  Chip
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';

const CompleteReviewDialog = ({ open, onClose, onSubmit, documents, reviewComment }) => {
  // 修改状态配置，添加 pending 状态
  const STATUS_CONFIG = {
    pending: {
      color: '#0288d1',
      bgColor: '#e3f2fd',
      icon: <AssignmentIcon fontSize="small" sx={{ color: '#0288d1' }} />,
      label: 'Pending'
    },
    approved: {
      color: '#2e7d32',
      bgColor: '#e8f5e9',
      icon: <CheckCircleIcon fontSize="small" sx={{ color: '#2e7d32' }} />,
      label: 'Approved'
    },
    rejected: {
      color: '#d32f2f',
      bgColor: '#ffebee',
      icon: <ErrorIcon fontSize="small" sx={{ color: '#d32f2f' }} />,
      label: 'Rejected'
    }
  };

  // 获取状态配置
  const getStatusConfig = (status) => {
    return STATUS_CONFIG[status.toLowerCase()] || STATUS_CONFIG.pending;
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle sx={{ 
        pb: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        color: '#1976d2'
      }}>
        <AssignmentIcon />
        Review Summary
      </DialogTitle>

      <DialogContent sx={{ pb: 4 }}>
        {/* 文档审核总结 */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Document Review Summary
          </Typography>
          {documents.map((doc, index) => {
            const statusConfig = getStatusConfig(doc.status);
            return (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  p: 2,
                  mb: 1,
                  border: '1px solid #e0e0e0',
                  borderLeft: `4px solid ${statusConfig.color}`,
                  bgcolor: statusConfig.bgColor,
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <Box>
                  <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                    {doc.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {doc.type} • Reviewed on {doc.reviewDate}
                  </Typography>
                </Box>
                <Chip
                  icon={statusConfig.icon}
                  label={statusConfig.label}
                  size="small"
                  sx={{
                    bgcolor: 'white',
                    color: statusConfig.color,
                    borderColor: statusConfig.color,
                    '& .MuiChip-icon': { color: 'inherit' }
                  }}
                />
              </Paper>
            );
          })}
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* 修改为 Review Note */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            Review Note
          </Typography>
          {reviewComment ? (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                border: '1px solid #e0e0e0',
                bgcolor: '#f8f9fa',
                borderLeft: '4px solid #1976d2'
              }}
            >
              <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.6 }}>
                {reviewComment}
              </Typography>
            </Paper>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
              No additional comments provided
            </Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, mt: 3 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{ color: '#666' }}
        >
          Continue Review
        </Button>
        <Button 
          onClick={onSubmit}
          variant="contained"
          color="primary"
          startIcon={<CheckCircleIcon />}
        >
          Complete Review
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteReviewDialog; 